module.exports = __webpack_public_path__ + "media/images/mobile/solutions/bg24-a717e59de2824c9f3994819a3ea0f7f2.png";